import {isValidElement} from 'rlink-react';

export function optionsWithDefaults (opts, defaults) {
  return Object.assign({}, defaults, opts);
}

export function merge (...objects) {
  return Object.assign({}, ...objects);
}

export function removeKeys (obj, keysToRemove) {
  if (Array.isArray(keysToRemove)) {
    let outObj = shallowCopy(obj);
    for ( let key of keysToRemove) {
      delete outObj[key];
    }
    return outObj;
  } else {
    let outObj = {};
    for (let key in obj) {
      if ( !(key in keysToRemove) ) {
        outObj[key] = obj[key];
      }
    }
    return outObj;
  }
}


export function shallowCopy (source) {
  if (Array.isArray(source)) {
    return source.slice();
  }
  if (typeof source === 'object' && source !== null) {
    return Object.assign({}, source);
  }
  if (typeof source === 'function') {
    throw new Error('Shallow copying functions has no obvious and useful meaning.');
  }
  // Only thing left are primitives that are all immutable and have value
  // identities - effectively making references indistinguishable from copies:
  return source;
}

// OOPy helpers

/**
 * Merges given `options` in-place into given `cls` object.
 *
 * This is a stopgap measure for dealing with inheriting from React
 * component classes until an official solution is decided on.
 *
 * Object properties are merged, all other values are overwritten.
 *
 * @param  {class} cls     a class object (i.e. constructor function)
 * @param  {object} options an object containing keys
 */
export function mergeStaticOptions (cls, options) {
  for (let key in options) {
    if ( !(key in cls) ) {
      cls[key] = options[key];
    } else {
      if (typeof cls[key] === 'object' && cls[key] !== null) {
        cls[key] = Object.assign({}, cls[key], options[key]);
      } else {
        cls[key] = options[key];
      }
    }
  }
}



// (deprecated by babel/ES6 classes!)
// @todo: REMOVE ME
export function subclass (parent, definition) {
  let constructor = function $constructor () {
    this.$parent = parent;
    if ( this.$constructor ) {
      // let subclass decide if it wants to call parent constructor
      return this.$constructor.apply(this, arguments);
    } else {
      // do call it by default though
      return this.$parent.apply(this, arguments);
    }
  };

  Object.assign(constructor, parent); // copy "statics"

  if (definition.$statics) {
    // add explicit '$statics' from subclass definition
    Object.assign(constructor, definition.$statics);
  }

  constructor.$parent = parent;

  constructor.prototype = Object.create(parent.prototype);

  Object.assign(constructor.prototype, definition);


  return constructor;
}




export function deepEquals (a, b) {
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'object') {
    if (a === null || b === null || a === undefined || b === undefined) {
      return a === b;
    }
    if (typeof a.equals === 'function') {
      return a.equals(b);
    }
    if (a instanceof Set) {
      if (b instanceof Set) {
        return deepEquals(Array.from(a), Array.from(b));
      } else {
        return false;
      }
    }
    if (a instanceof Map) {
      if (b instanceof Map) {
        return deepEquals(Array.from(a), Array.from(b));
      } else {
        return false;
      }
    }
    if (a instanceof WeakMap || b instanceof WeakSet) {
      throw new Error('Weak data structures cannot be compared.');
    }
    if (Array.isArray(a)) {
      if (!Array.isArray(b)) {
        return false;
      }
      if (a.length !== b.length) {
        return false;
      }
      for (var i = a.length - 1; i >= 0; i--) {
        if (!deepEquals(a[i], b[i]) ) {
          return false;
        }
      }
      return true;
    } else if (a instanceof Date
        || a instanceof RegExp
        || a instanceof String
        || a instanceof Number) {
      return b.constructor === a.constructor && a.toString() === b.toString();
    } else if (isValidElement(a)) {
      if (!isValidElement(b)) {
        return false;
      }
      return deepEquals(a.props, b.props) && deepEquals(a.state, b.state);

    } else {
      for (var key in b) {
        if (!(key in a)) {
          return false;
        }
      }
      for (var key in a) {
        if (!(key in b) || !deepEquals(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }

  }
  // non-object primitives
  return a === b;
}


export function makeMap (object) {
  if (object instanceof Map) {
    return object;
  }
  if (typeof object.toJS === 'function') {
    object = object.toJS();
  }
  let map = new Map();
  for (let key in object) {
    map.set(key, object[key]);
  }
  return map;
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/object.js